/** Лимиты на одно пользовательское сообщение (личка + согласованность с сервером). */
export const MESSENGER_MAX_FILE_BYTES = 10 * 1024 * 1024;

/** Подпись лимита в текстах для пользователя (как в ProjectFilesPopover). */
export const MESSENGER_MAX_FILE_SIZE_LABEL = '10 МБ';

/** Слишком большой файл — с именем, в духе ProjectFilesPopover. */
export function messengerDmFileTooLargeMessage(fileLabel: string): string {
  const name = fileLabel.trim() || 'файл';
  return `Файл «${name}» слишком большой. В личном чате можно отправить вложение до ${MESSENGER_MAX_FILE_SIZE_LABEL}. Выберите другой файл или уменьшите его размер.`;
}

export const MESSENGER_MAX_FILES_PER_MESSAGE = 1;
export const MESSENGER_MAX_CONTEXT_ATTACHMENTS_PER_MESSAGE = 1;

/** Взаимоисключение: файл / проект / сессия — не более одного вида за раз. */
export const MESSENGER_EXCLUSIVE_ATTACHMENTS_HINT =
  'В одном сообщении нельзя совмещать файл и контекст (проект или сессия). Уберите одно из вложений или отправьте их отдельными сообщениями.';

export const AGENT_EXCLUSIVE_ATTACHMENTS_HINT =
  'Можно прикрепить что-то одно: фото, проект, сессия или планер.';

/** Личка: слот файла занят — не заменять автоматически */
export const MESSENGER_DM_SINGLE_FILE_SLOT_OCCUPIED =
  'К этому сообщению уже прикреплён файл. Чтобы выбрать другой, сначала нажмите крестик на карточке вложения — тогда сможете добавить новый файл, фото или вставку из буфера.';

export const MESSENGER_DM_ONLY_ONE_FILE_ALLOWED =
  'За раз можно прикрепить только один файл. Если вы выбрали или перетащили несколько, оставьте один — или отправьте файлы отдельными сообщениями.';

export const MESSENGER_DM_PREPARE_FILE_FAILED =
  'Не получилось подготовить файл к отправке. Попробуйте другой формат или файл поменьше. Если проблема повторяется — обновите страницу.';

export const MESSENGER_DM_FILE_STILL_TOO_LARGE_AFTER_PROCESS =
  `После сжатия изображения оно всё ещё больше ${MESSENGER_MAX_FILE_SIZE_LABEL}. Выберите другое фото или уменьшите разрешение в редакторе, затем попробуйте снова.`;

/** Черновик пересылки в композере — файлы и контекст (проект/сессия) недопустимы до отправки или отмены. */
export const MESSENGER_DM_NO_ATTACH_WHILE_FORWARD =
  'К сообщению с пересылкой нельзя прикрепить вложение. Отправьте или отмените пересылку, затем добавьте файл, фото или контекст.';
